<template>
  <DialogHeader>
    <template #right>
      <div class="font-medium text-green-900 cursor-pointer" @click="close()">
        Close
      </div>
    </template>
    Dacr Timestamps
  </DialogHeader>
  <DialogContent class="h-full flex flex-col overflow-hidden">
    <div class="mb-[14px]">
      Certified registration timestamps for each jurisdiction where this work is
      registered.
    </div>

    <Table.Base class="flex flex-col">
      <Table.Headers>
        <Table.Header> Jurisdiction </Table.Header>
        <Table.Header class="hidden tablet-h:flex">
          Dacr Timestamp
        </Table.Header>
        <Table.Header></Table.Header>
      </Table.Headers>

      <div class="overflow-y-auto">
        <Table.Row
          v-for="registration in registrations"
          :key="registration.origin.id"
        >
          <Table.Cell class="tablet-h:h-10!">
            <div class="mr-2.5">
              <div
                class="size-[24px] border-2 border-gray-600/15 rounded-full flex items-center justify-center bg-white"
              >
                <Icon name="Dacr" :size="16" />
              </div>
            </div>
            <div>
              <div
                class="font-secondary text-[14px] leading-[18px] text-gray-800"
              >
                {{ registration.origin.name }}
              </div>
              <div class="tablet-h:hidden text-gray-500">
                {{ formatTimestamp(registration.timestamp) }}
              </div>
            </div>
          </Table.Cell>
          <Table.Cell class="hidden tablet-h:flex">
            {{ formatTimestamp(registration.timestamp) }}
          </Table.Cell>
          <Table.Cell>
            <a
              v-if="registration.certificateUrl"
              :href="registration.certificateUrl"
              target="_blank"
              class="flex items-center text-[14px] leading-[22px] gap-x-1"
            >
              <Icon name="File" :size="14" class="stroke-green-700" />
              <div class="text-link">Certificate</div>
            </a>
          </Table.Cell>
        </Table.Row>
      </div>
    </Table.Base>
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-1/2 tablet-h:w-auto" primary @click="close()">
      Close
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, Table, Icon } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import type { File } from '@/shared/graphql/router/graphql'
import { computed } from 'vue'
import { formatTimestamp } from '@/shared/utils/datetime'

const props = defineProps<{
  file: File
}>()

const { close } = useDialog()

const registrations = computed(() => props.file.copyright?.registrations ?? [])
</script>
